export const claimDecisions = [`Open`, `Approved`, `Denied`, 'AdminClosed'];
export const fastTrackOptions = [
    {
        true: 'Yes',
        false: 'No'
    }
];
